(function () {
	'use strict';
	$(document).ready(function () {

		document.querySelectorAll('form.report-form').forEach((form) => {
			// Handle form submission
			form.addEventListener('submit', async (event) => {
				await handleSubmit(event)
			});
		});

		$('#save').on('click', function () {
			localStorage.clear();
			$(this).text(fhTranslate('zapisano'));
			$('input, textarea').each(function () {
				const input = $(this);
				localStorage.setItem(input.attr('name'), input.val());
				if (input.is(':checked')) {
					localStorage.setItem(input.attr('name'), 'set');
				}
			});
		});

		$('input[type="text"],input[type="email"],input[type="tel"], textarea').each(function () {
			const input = $(this);
			if (localStorage.getItem(input.attr('name'))) {
				input.val(localStorage.getItem(input.attr('name')));
			}
		});

		$('input[type="checkbox"]').each(function () {
			const input = $(this);
			if (localStorage.getItem(input.attr('name')) === 'set') {
				input.prop('checked', true);
			}
		});

		$('.js-content-accordion-expand').on('click', function () {
			$(this).siblings('.expanded-content').slideToggle();
		});

		//Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		document.querySelectorAll('input[type="file"]').forEach((input) => {
			input.addEventListener('change', () => {
				const fileName = input.files[0].name;
				const label = input.parentElement.querySelector('label');
				label.textContent = fileName;
			});
		});

		function getFieldset(field) {
			if (!field) {
				console.log('no field', field);
				return false;
			}

			const fieldset = field.closest('fieldset.field');

			if (!fieldset) {
				console.log('no fieldset', field);
				return false;
			}

			return fieldset;
		}

		function addError(field, errorMessage) {
			const fieldset = getFieldset(field);
			if (!fieldset) return;
			fieldset.classList.add('error', 'field--error');
			field.classList.add('error', 'input--error');

			const errorContainer = fieldset.querySelector('.error-container');
			errorContainer.textContent = errorMessage;
		}

		function getFormData(form, additionalData = {}) {
			const formData = new FormData(form);

			for (const [key, value] of Object.entries(additionalData)) {
				formData.append(key, value);
			}

			return formData;
		}

		function validateForm(form) {
			form.classList.remove('invalid');
			let isValid = form.checkValidity();
			const formGroups = form.querySelectorAll('tr.form-group');
			formGroups.forEach(formGroup => {
				formGroup.classList.remove('invalid');
			});

			const fileInputs = form.querySelectorAll('input[type="file"]');
			fileInputs.forEach(input => {
				if (input.files.length > 0) {
					const file = input.files[0];
					const fileSizeMB = file.size / 1024 / 1024;
					const fileExtension = file.name.split('.').pop().toLowerCase();

					if (fileSizeMB > 10 || (fileExtension !== 'xls' && fileExtension !== 'pdf' && fileExtension !== 'xlsx')) {
						input.classList.add('invalid-file');
						input.parentElement.querySelector('label').textContent = fhTranslate('blad-walidacji-pliku');
						isValid = false;
					} else {
						input.classList.remove('invalid-file');
					}
				}
			});

			const invalidElements = form.querySelectorAll('input:invalid, textarea:invalid, .invalid-file');
			invalidElements.forEach(element => {
				let parentFormGroup = element.closest('tr.form-group');
				if (parentFormGroup) {
					parentFormGroup.classList.add('invalid');
				}
			});

			if (!isValid) {
				$(form).find('.expanded-content').slideDown();
				form.classList.add('invalid');
				const firstInvalidElement = invalidElements[0];
				if (firstInvalidElement) {
					firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			}

			return isValid;
		}

		async function handleSubmit(e) {
			e.preventDefault();
			const form = e.target;

			if (form.classList.contains('submitting')) {
				return;
			}

			const submit = form.querySelector('[type="submit"]');
			const currentSubmitText = submit.textContent;
			addError(form.querySelector('[type="submit"]'), '');

			try {

				const isFormValid = validateForm(form);
				if (!isFormValid) {
					addError(form.querySelector('[type="submit"]'), fhTranslate('blad-walidacji'));
					return;
				}

				form.classList.add('submitting');
				submit.disabled = true;
				submit.textContent = fhTranslate('wysylanie');

				form.querySelectorAll('input[type="checkbox"]').forEach(element => {
						if (!element.checked) {
							element.setAttribute('value', 'NIE');
							element.classList.remove('checkbox');
							element.checked = true;
						}
					}
				);

				const dataObject = getFormData(form);

				const json = await fetch(`../wp-json/form/form-handler`, {
					method: 'POST',
					body: dataObject,
				}).then((response) => response.json());
				if (!json?.success) {
					throw new Error(json?.data?.[0]?.message || 'Coś poszło nie tak');
				} else {
					form.reset();
					localStorage.clear();
					addError(form.querySelector('[type="submit"]'), fhTranslate('pomyslnie-wyslano'));
					form.querySelectorAll('input[type="checkbox"]').forEach(element => {element.classList.add('checkbox')});
					form.querySelectorAll('input[type="file"]').forEach(input => {
						input.parentElement.querySelector('label').textContent = fhTranslate('dodaj-zalacznik');
					});
				}
			} catch (error) {
				addError(form.querySelector('[type="submit"]'), fhTranslate('blad-wysylki'));
			} finally {
				form.classList.remove('submitting');
				submit.textContent = currentSubmitText;
				submit.disabled = false;
			}
		}
	});
}(jQuery));
